import { useLang } from "../../lib/LanguageContext";
import { BRAND } from "../../lib/brand";
import { Check, ArrowRightLeft } from "lucide-react";

export default function Ecosystem() {
  const { t } = useLang();

  const supplierBenefits = [t.ecosystem.supplierBenefit1, t.ecosystem.supplierBenefit2, t.ecosystem.supplierBenefit3];
  const traderBenefits = [t.ecosystem.traderBenefit1, t.ecosystem.traderBenefit2, t.ecosystem.traderBenefit3];

  return (
    <section id="ecosystem" className="py-20 sm:py-28 bg-white border-y border-soft relative overflow-hidden" data-testid="ecosystem-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-widest text-brand-red">{t.ecosystem.eyebrow}</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight" data-testid="ecosystem-title">
            {t.ecosystem.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-ink-muted leading-relaxed">{t.ecosystem.subtitle}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-[1fr_auto_1fr] gap-6 lg:gap-10 items-stretch">
          {/* Suppliers */}
          <div className="rounded-3xl bg-[#FAFAFA] border border-soft p-8 hover:-translate-y-1 transition-transform duration-300" data-testid="supplier-card">
            <div className="inline-block px-3 py-1 rounded-full bg-brand-orange/15 text-brand-orange text-xs font-bold uppercase tracking-wider mb-4">
              Supplier
            </div>
            <h3 className="font-display font-bold text-2xl text-ink mb-5">{t.ecosystem.supplierSide}</h3>
            <ul className="space-y-3">
              {supplierBenefits.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-brand-orange flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <span className="text-ink">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Center hub with mascot */}
          <div className="hidden lg:flex flex-col items-center justify-center relative">
            <div className="absolute w-40 h-40 rounded-full bg-brand-red/10 blur-2xl" />
            <div className="relative w-28 h-28 rounded-3xl bg-ink flex items-center justify-center soft-shadow">
              <img src={BRAND.mascot} alt="AsCom hub" className="w-24 h-24 rounded-2xl object-cover" />
            </div>
            <div className="mt-4 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-ink-muted">
              <ArrowRightLeft className="w-4 h-4" />
              <span>AsCom HUB</span>
            </div>
          </div>

          {/* Traders */}
          <div className="rounded-3xl bg-ink text-white p-8 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden" data-testid="trader-card">
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-brand-red/40 blur-3xl pointer-events-none" />
            <div className="relative">
              <div className="inline-block px-3 py-1 rounded-full bg-brand-red/20 text-white text-xs font-bold uppercase tracking-wider mb-4">
                Reseller
              </div>
              <h3 className="font-display font-bold text-2xl mb-5">{t.ecosystem.traderSide}</h3>
              <ul className="space-y-3">
                {traderBenefits.map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-brand-red flex items-center justify-center shrink-0 mt-0.5">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-white/90">{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-testid="trust-stats">
          {[
            { n: "2.800+", l: "Active Resellers" },
            { n: "380+", l: "Verified Suppliers" },
            { n: "12", l: "Countries" },
            { n: "+185%", l: "Avg Profit Margin" },
          ].map((s) => (
            <div key={s.l} className="text-center rounded-2xl bg-cream border border-soft p-6">
              <div className="font-display font-extrabold text-3xl sm:text-4xl text-brand-red">{s.n}</div>
              <div className="text-xs font-semibold uppercase tracking-wider text-ink-muted mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
